// src/music-pjax.js

function isMusicLink(anchor) {
  if (!anchor || !anchor.href) return false;

  const url = new URL(anchor.href, window.location.origin);

  // Only handle same-origin links
  if (url.origin !== window.location.origin) return false;

  // Only handle /music routes
  if (!url.pathname.startsWith('/music')) return false;

  // Allow opting out of PJAX on specific links
  if (anchor.hasAttribute('data-sv-no-pjax')) return false;

  return true;
}

function getMainFromHTML(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // We only ever swap <main data-sv-main="true">
  return doc.querySelector('main[data-sv-main="true"]');
}

async function loadPage(url, options = {}) {
  const { pushState = true } = options;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load ${url}: ${response.status}`);
    }

    const html = await response.text();
    const newMain = getMainFromHTML(html);

    if (!newMain) {
      throw new Error('No <main data-sv-main="true"> found in response');
    }

    const currentMain = document.querySelector('main[data-sv-main="true"]');
    if (!currentMain) {
      throw new Error('Current <main data-sv-main="true"> not found');
    }

    // Swap the main content
    currentMain.replaceWith(newMain);

    // Update document title from fetched document
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc.title) {
      document.title = doc.title;
    }

    if (pushState) {
      window.history.pushState(
        { svPjax: true, url },
        '',
        url,
      );
    }

    // Scroll to top (or adjust to taste)
    window.scrollTo(0, 0);

    // Re-run page init so playlists, album clicks, etc. are wired for the new content
    if (typeof window.svPageInit === 'function') {
      window.svPageInit();
    }
  } catch (err) {
    console.error('[SV PJAX] Navigation failed, falling back to full load:', err);
    window.location.href = url;
  }
}

function handleClick(event) {
  const anchor = event.target.closest('a');
  if (!anchor) return;

  // Let browser handle modified clicks (new tab, etc.)
  if (
    event.defaultPrevented ||
    event.button !== 0 ||     // not left-click
    event.metaKey ||         // cmd-click
    event.ctrlKey ||         // ctrl-click
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  // Links with target="_blank" etc. should behave normally
  if (anchor.target && anchor.target !== '_self') {
    return;
  }

  if (!isMusicLink(anchor)) return;

  event.preventDefault();
  const url = anchor.href;

  loadPage(url, { pushState: true });
}

function handlePopState(event) {
  const state = event.state;

  if (!state || !state.svPjax || !state.url) {
    // Not a PJAX-managed history entry; let the browser do its thing
    return;
  }

  loadPage(state.url, { pushState: false });
}

export function initMusicPjax() {
  // Only run once
  if (window.__SV_MUSIC_PJAX_INITED) return;
  window.__SV_MUSIC_PJAX_INITED = true;

  document.addEventListener('click', handleClick);
  window.addEventListener('popstate', handlePopState);
}
